import { type ParameterConfigKey } from '@/types/measurements';

import type { ParameterLabel } from './types';

// TODO: split into separate files per activity type (e.g., walk parameters, standard measurement parameters)
type EnParameterLabelsTranslations = {
  parameters: Partial<Record<ParameterConfigKey, ParameterLabel>>;
};

export const enParameterLabelsTranslations: EnParameterLabelsTranslations = {
  parameters: {
    walk_score: {
      displayName: 'Walk Score',
    },
    velocity: {
      displayName: 'Velocity',
    },
    velocity_variability: {
      displayName: 'Velocity Variability',
    },
    consistency: {
      displayName: 'Consistency',
    },
    // TODO: 'distance' is not in ParameterConfigKey — verify if this key is still needed
    ['distance' as ParameterConfigKey]: {
      displayName: 'Distance',
    },
    cadence: {
      displayName: 'Cadence',
    },
    cadence_variability: {
      displayName: 'Cadence Variability',
    },
    double_support: {
      displayName: 'Double Support',
    },
    single_support_left: {
      displayName: 'Single Support Left',
    },
    single_support_right: {
      displayName: 'Single Support Right',
    },
    stance_left: {
      displayName: 'Stance Left',
    },
    stance_right: {
      displayName: 'Stance Right',
    },
    stance_asymmetry: {
      displayName: 'Stance Asymmetry',
    },
    double_support_asymmetry: {
      displayName: 'Double Support Asymmetry',
    },
    stride_length: {
      displayName: 'Stride Length',
    },
    step_length_left: {
      displayName: 'Step Length Left',
    },
    step_length_right: {
      displayName: 'Step Length Right',
    },
    step_length_asymmetry: {
      displayName: 'Step Length Asymmetry',
    },
    base_width: {
      displayName: 'Base Width',
    },
    hip_range: {
      displayName: 'Hip Range',
    },
    sts_repetition_count: {
      displayName: 'STS Count',
      longDisplayName: 'Sit to Stand',
      acronym: 'STS',
    },
    sts_angle: {
      displayName: 'STS Angle',
      acronym: 'STS',
    },
    sts_repetition_var: {
      displayName: 'STS Repetition Variability',
      acronym: 'STS',
    },
    sts_repetition_time: {
      displayName: 'STS Repetition Time',
      acronym: 'STS',
    },
    tug_duration_seconds: {
      displayName: 'TUG Duration',
      longDisplayName: 'Timed Up and Go',
      acronym: 'TUG',
    },
    tug_turning_seconds: {
      displayName: 'TUG Turning',
      acronym: 'TUG',
    },
    tug_standing_seconds: {
      displayName: 'TUG Standing',
      acronym: 'TUG',
    },
    tug_turning_to_chair_seconds: {
      displayName: 'TUG Turning to Chair',
      acronym: 'TUG',
    },
    tug_sitting_seconds: {
      displayName: 'TUG Sitting',
      acronym: 'TUG',
    },
    six_minute_walk_distance_meters: {
      displayName: '6MW Distance',
      longDisplayName: '6 Minute Walk',
      acronym: '6MW',
    },
    two_minute_walk_distance_meters: {
      displayName: '2MW Distance',
      longDisplayName: '2 Minute Walk',
      acronym: '2MW',
    },
    functional_reach: {
      displayName: 'Functional Reach',
    },
    functional_reach_distance_cm: {
      displayName: 'Functional Reach Distance',
      acronym: 'FRT',
    },
  },
};
